import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-metering-and-billing-brand))",
      d: "M12.025 21a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712v-1.15a5.2 5.2 0 0 1-1.975-.875q-.85-.625-1.375-1.75a.85.85 0 0 1-.013-.738q.163-.387.588-.562a.88.88 0 0 1 .725.012q.375.163.575.538.425.75 1.075 1.138t1.6.387q1.025 0 1.738-.462.712-.463.712-1.438 0-.875-.55-1.387-.55-.513-2.55-1.163-2.15-.675-2.95-1.613t-.8-2.287q0-1.625 1.05-2.525t2.15-1.025V4q0-.424.287-.712A.97.97 0 0 1 12.026 3q.424 0 .713.288.287.287.287.712v1.1q.95.15 1.65.613t1.15 1.137q.226.325.088.725a.94.94 0 0 1-.563.575.95.95 0 0 1-.725.012 1.8 1.8 0 0 1-.7-.487 2.2 2.2 0 0 0-.763-.537q-.437-.188-1.087-.188-1.1 0-1.675.487-.575.488-.575 1.213 0 .825.75 1.3t2.6 1q1.724.5 2.612 1.588.888 1.086.888 2.512 0 1.774-1.05 2.7-1.05.925-2.6 1.15V20q0 .424-.287.712a.97.97 0 0 1-.713.288"
    }, null, -1)
  ]))]))
}
export default { render: render }